'use client';

import A2UIPreviewPage, { type A2UIPreviewCopy } from '../preview/A2UIPreviewPage';
import type { A2UIGalleryExample } from './a2uiGalleryExamples';

export default function A2UIGalleryDetailPage({ example: _example, raw, monacoSsrHtml, previewCopy }: { example: A2UIGalleryExample; raw: string; monacoSsrHtml?: string; previewCopy: A2UIPreviewCopy }) {
  return (
    <section className="flex h-full min-h-0 w-full min-w-0 flex-col py-1">
      <div className="min-h-0 min-w-0 flex-1 overflow-visible">
        <A2UIPreviewPage initialRaw={raw} monacoSsrHtml={monacoSsrHtml} copy={previewCopy} layout="embedded" className="h-full" documentKey={`gallery:${_example.id}`} />
      </div>
    </section>
  );
}
